import React, { useEffect, useState } from 'react';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import TabModuleDesktop from './tabModuleDesktop/tabModuleDesktop';
import TabModuleMobile from './tabModuleMobile/tabModuleMobile';
import styles from './tabModuleMain.module.scss';

function TabModuleMain({ mobileView, ...tabProps }) {
  const { width } = useWindowDimensions();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (width < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [width]);

  return isMobile || mobileView ? (
    <div className={styles.tabModuleMobileWrapper}>
      <TabModuleMobile {...tabProps} />
    </div>
  ) : (
    <div className={styles.tabModuleDesktopWrapper}>
      <TabModuleDesktop {...tabProps} />
    </div>
  );
}
export default TabModuleMain;
